import { t } from "../../../services/utils";
import React from "react";
import { connect } from "react-redux";
import { GET_GROUPS, GET_TRAINERS } from "../../../constants/action-types";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import Popover from "@material-ui/core/Popover";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import { STORY_VIEW_WIDTH } from "../../../constants/values";
import storyTypes from "../../../constants/storyTypes";
import ClientsFilter from "../../../components/ClientsFilter";
import _ from "lodash";
import { storyListViewTypes } from "../StoryListView";
const StoryFilter = (props) => {
  let styles = {
    option: {
      // marginTop: 10,
      display: "flex",
      alignItems: "center",
      borderBottom: "1px solid #e0e0e0",
      // padding: "10px 5px",
    },

    checkbox: {
      padding: 10,
    },
  };
  return (
    <div style={styles.option}>
      <Checkbox
        key={props.value.toString()}
        value={props.value.toString()}
        checked={props.checked}
        onChange={(e) => {
          e.stopPropagation();
          props.onChange(e);
        }}
        color="primary"
        style={styles.checkbox}
      />
      {props.label}
    </div>
  );
};
class FilterView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showFilters: false,
      anchorEl: null,
      anchorElClientsFilter: null,
      filterSelectOpen: false,
    };
  }
  componentDidMount = () => {
    if (_.isEmpty(this.props.trainers)) {
      this.props.getTrainers();
    }
    if (_.isEmpty(this.props.groups)) {
      this.props.getGroups();
    }
  };
  handleFilterChange = (e, child) => {
    const val = e.target.value;
    this.setState({
      selectVal: val,
    });
    this.props.onChange(FilterView.getObjectFromKey(val));
  };
  handleFilterOpen = () => {
    this.setState({
      filterSelectOpen: true,
    });
  };
  handleFilterClose = () => {
    this.setState({
      filterSelectOpen: false,
    });
  };
  handleClick = (event) => {
    event.stopPropagation();
    this.setState({
      anchorEl: event.currentTarget,
    });
  };
  handleClose = (event) => {
    event.stopPropagation();
    this.setState({
      anchorEl: null,
    });
  };
  handleClientsFilterClick = (event) => {
    event.stopPropagation();
    this.setState({
      anchorElClientsFilter: event.currentTarget,
    });
  };
  handleClientsFilterClose = (event) => {
    event.stopPropagation();
    this.setState({
      anchorElClientsFilter: null,
    });
  };
  getStoryTypes = () => {
    return [
      // { label: "All Posts", value: "all" },
      {
        label: t("checkIn"),
        value: storyTypes.CHECKIN,
      },
      {
        label: t("assessment"),
        value: storyTypes.ASSESSMENT,
      },
      {
        label: t("progressPhoto"),
        value: storyTypes.PROGRESS_PHOTO,
      },
      {
        label: t("meal"),
        value: storyTypes.MEAL_LOG,
      },
      {
        label: t("post"),
        value: storyTypes.POST,
      },
      {
        label: t("workout"),
        value: storyTypes.WORKOUT_LOG,
      },
    ];
  };
  getSelectedStoriesLabel = () => {
    let label = "";
    const { selectedStoryTypes, allStoryTypes } = this.props;
    if (!allStoryTypes && selectedStoryTypes.length > 0) {
      this.getStoryTypes().map((type) => {
        if (selectedStoryTypes.indexOf(type.value) >= 0) {
          label += ` ${type.label}, `;
        }
      });
      return label.replace(/, +$/, "");
    } else {
      return t("All");
    }
  };
  render = () => {
    const styles = {
      empty: {
        height: 62,
        width: this.props.width,
      },
      header: {
        marginTop: 20,
        marginBottom: 5,
        paddingLeft: 40,
        display: "flex",
        justifyContent: "space-between",
        fontWeight: "bold",
      },
      filtersContainer: {
        position: "absolute",
        width: STORY_VIEW_WIDTH - 6 - 80,
        left: 3,
        height: 400,
        marginTop: 10,
        padding: 40,
      },
      sectionHeading: {
        fontSize: 16,
        fontWeight: "bold",
        color: "#2A234E",
        letterSpacing: 0.45,
      },
      filters: {
        display: "flex",
        justifyContent: "space-between",
      },
      optionInput: {
        padding: 0,
        paddingRight: 10,
      },
      option: {
        marginTop: 30,
        display: "flex",
        alignItems: "center",
      },
      labelBtn: {
        textTransform: "unset",
        fontSize: 14,
        fontWeight: "400",
        color: "black",
        background: "white",
        height: 42,
        marginRight: 10,
        borderRadius: 6,
      },
      option: {
        // marginTop: 10,
        // padding: "10px 5px",
        display: "flex",
        alignItems: "center",
        borderBottom: "1px solid #e0e0e0",
      },
      checkbox: {
        padding: 10,
        // padding: 5,
        // paddingRight: 10
      },

      menuItem: {
        paddingLeft: 40,
        paddingTop: 6,
        paddingBottom: 6,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "block",
      },
    };
    if (_.isEmpty(this.props.trainers) || _.isEmpty(this.props.groups)) {
      return <div style={styles.empty} />;
    }
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);
    const {
      selectedStoryTypes,
      onStoryTypeFilterChange,
      forAll,
      forTrainer,
      id,
      onChange,
      allStoryTypes,
      handleAllStoryTypes,
      viewType,
    } = this.props;
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <Button
          color="default"
          variant="outlined"
          onClick={this.handleClick}
          style={styles.labelBtn}
          data-testid="story-type-filter"
        >
          {/* All Posts */}
          {this.getSelectedStoriesLabel()}
          {open ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
        </Button>
        {viewType === storyListViewTypes.FOR_NEWS && (
          <ClientsFilter
            onFilterChange={onChange}
            forAll={forAll}
            forTrainer={forTrainer}
            id={id}
            onChange={onChange}
            filterGroups
            disableUnderline
          />
        )}
        <Popover
          id="simple-popper"
          open={open}
          anchorEl={anchorEl}
          onClose={this.handleClose}
          anchorOrigin={{
            horizontal: "right",
            vertical: "bottom",
          }}
          transformOrigin={{
            horizontal: "right",
            vertical: "top",
          }}
          PaperProps={{
            style: {
              width: 220,
              paddingTop: 5,
              paddingBottom: 5,
            },
          }}
        >
          <div style={styles.options}>
            <div style={styles.option}>
              <Checkbox
                key="all"
                value="all"
                checked={allStoryTypes}
                onChange={(e) => {
                  e.stopPropagation();
                  handleAllStoryTypes(e);
                }}
                color="primary"
                style={styles.checkbox}
              />
              {t("allPosts")}
            </div>
            {this.getStoryTypes().map((type) => {
              return (
                <StoryFilter
                  key={type.value}
                  value={type.value}
                  label={type.label}
                  checked={
                    selectedStoryTypes.indexOf(type.value) >= 0 || allStoryTypes
                  }
                  onChange={(e) => onStoryTypeFilterChange(e)}
                />
              );
            })}
          </div>
        </Popover>
      </div>
    );
  };
  static getObjectFromKey(key) {
    if (key === "all") {
      return {
        forAll: true,
        forTrainer: false,
        id: 0,
      };
    } else {
      let split = key.split("-");
      if (split[0] === "tr") {
        return {
          forAll: false,
          forTrainer: true,
          id: parseInt(split[1]),
        };
      } else {
        return {
          forAll: false,
          forTrainer: false,
          id: parseInt(split[1]),
        };
      }
    }
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    getTrainers: () => {
      dispatch({
        type: GET_TRAINERS.REQUEST,
      });
    },
    getGroups: () => {
      dispatch({
        type: GET_GROUPS.REQUEST,
      });
    },
  };
};
const mapStateToProps = (state) => {
  return {
    trainers: state.trainers,
    groups: state.groups,
    me: state.me,
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(FilterView);
